import React from 'react';
export const MenuData_Sponsor = [
    {
        name: "Home",
        level: "1",
        url: "/SponsorDashboard",
        children: [
            {
                name: "Dashboard",
                level: "2",
                url: "/",
                children: [
                    {
                        name: "Sponsor Dashboard",
                        level: "3",
                        url: "/SponsorDashboard"
                    },
                    {
                        name: "Study Dashboard",
                        level: "3",
                        url: "/SponsorStudyList"
                    },
                    {
                        name: "Query Dashboard",
                        level: "3",
                        url: "/SiteQueryDashboard?Action=view"
                    },
                    {
                        name: "Custom Report",
                        level: "3",
                        url: "/CustomViewerList"
                    },
                    {
                        name: "Documents",
                        level: "3",
                        url: "/DocumentMgmtList"
                    }
                ]
            },
            {
                name: "Report",
                level: "2",
                url: "",
                children: [
                    {
                        name: "Global Report Viewer",
                        level: "3",
                        url: "/GlobalReportViewer"
                    }
                ]
            }
        ]
    },
    {
        name: "Help",
        level: "1",
        url: "/",
        children: [
            {
                name: " ",
                level: "2",
                url: ""
            }]
    },
    {
        name: "Contact Support",
        level: "1",
        url: "/",
        children: [
            {
                name: " ",
                level: "2",
                url: ""
            }]
    },
    {
        name: "About",
        level: "1",
        url: "/AboutUs",
        children: [
            {
                name: " ",
                level: "2",
                url: ""
            }]
    }
]